import axios from 'src/api/Api';
import {
    GET_CHECK_ORDER_ACTION_ELIGIBILITY_SUCCESS,
    GET_CHECK_ORDER_ACTION_ELIGIBILITY_FAILURE, 
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* checkOrderActionEligibilitySaga(action) {
    const params = convertObjectToQueryParams({
        action: action.payload.action,
        myCaseRef: action.payload.myCaseRef,
        orderType: action.payload.orderType
    });

    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/checkOrderActionEligibility?${params}`;

    try {
        const response = yield axios.get(url);
        if (response && response.data) {
            yield put({
                type: GET_CHECK_ORDER_ACTION_ELIGIBILITY_SUCCESS,
                data: response.data,
            });
        } else {
            // If response is malformed, treat as error
            yield put({
                type: GET_CHECK_ORDER_ACTION_ELIGIBILITY_FAILURE,
                statusCode: '500',
                statusMessage: 'Malformed response from server',
            });
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        let statusCode = '503';
        let statusMessage = errorHandler('503');
        if (error.response) {
            statusCode = error.response.data?.statusCode || error.response.status;
            statusMessage = error.response.data?.statusMessage || errorHandler(statusCode);
        }
        yield put({
            type: GET_CHECK_ORDER_ACTION_ELIGIBILITY_FAILURE,
            statusCode,
            statusMessage,
        });
    }
}